export const benchmarksMutationTypes = {
  ADD_BENCHMARKS_LIST: 'ADD_BENCHMARKS_LIST',
  ADD_CHANNEL_LIST: 'ADD_CHANNEL_LIST',
  ADD_PAGE_GROUPS: 'ADD_PAGE_GROUPS',
  ADD_COLOR_LIST: 'ADD_COLOR_LIST',
};
